import './App.css'
import React, { useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import OutdoorSensor from './components/OutdoorSensor'
import FirstIndoorSensor from './components/FirstIndoorSensor'
import Home from './components/Home'
import NaviMenu from './components/NaviMenu'
import WasteHeat from './components/WasteHeat'
import SolarEnergyCalculator from './components/SolarEnergyCalculator'
import WasteHeatCalculator from './components/WasteHeatCalculator'
import Footer from './components/Footer'
import PilotSites from './components/PilotSites'
import PilotSiteOunas from './components/PilotSiteOunas'
import PilotSiteAreena from './components/PilotSiteAreena'
import Calculators from './components/Calculators'
import Ounashalli from './components/Ounashalli'
import LappiAreena from './components/LappiAreena'
const App = () => {
  const [ datas, setDatas ] = useState([])
  const [ start, setStart ] = useState(new Date())
  const [ end, setEnd ] = useState(new Date())
  const [ message, setMessage ] = useState(null)

  return (
    <div className="App-head">
      <Router>
        <NaviMenu />
        <Footer />
        <div className="App">
          <Switch>
            <Route path="/Ulkolampotila">
              <OutdoorSensor message={message} setMessage={setMessage} start={start} setStart={setStart} end={end} setEnd={setEnd} datas={datas} setDatas={setDatas} />
            </Route>
            <Route path="/Sisailma-1">
              <FirstIndoorSensor datas={datas} setDatas={setDatas}/>
            </Route>
            <Route path="/lappi-areena/WasteHeat">
              <WasteHeat />
            </Route>
            <Route path="/Calculators/SolarEnergy">
              <SolarEnergyCalculator />
            </Route>
            <Route path="/Calculators/WasteHeat">
              <WasteHeatCalculator />
            </Route>
            <Route path="/Pilot-sites/Ounasinfo">
              <Ounashalli />
            </Route>
            <Route path="/Pilot-sites/Ounashalli">
              <PilotSiteOunas />
            </Route>
            <Route path="/Pilot-sites/Areenainfo">
              <LappiAreena />
            </Route>
            <Route path="/Pilot-sites/Lappi-Areena">
              <PilotSiteAreena />
            </Route>
            <Route path="/Pilot-sites/">
              <PilotSites />
            </Route>
            <Route path="/Calculators">
              <Calculators />
            </Route>
            <Route path="/">
              <Home />
            </Route>
          </Switch>
        </div>
      </Router>
    </div>
  )
}



export default App
